import type { ReactElement } from 'react'
import React from 'react'

import { informationList } from '@ui-kit/components/listComponents/InformationList/styles'
import { body2, h4 } from '@ui-kit/core/typography'

import type { ListProps } from './types'

const InformationList = (props: ListProps): ReactElement => {
  const { container, item, titleContainer, title } = informationList()
  return (
    <ul className={container()}>
      {props.listData.map((listItemData) => {
        return (
          <li key={listItemData.id} className={item()}>
            <div className={titleContainer()}>
              {listItemData.icon}
              <span className={h4({ className: title() })}>{listItemData.title}</span>
            </div>
            <span className={body2({ emphasis: 'medium' })}>{listItemData.description}</span>
          </li>
        )
      })}
    </ul>
  )
}

export default InformationList
